var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 27,
    fill: "none",
    viewBox: "0 0 25 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13A55B",
    d: "M24.068 12.307c0 6.605-4.795 12.79-11.345 14.6a2.65 2.65 0 0 1-1.378 0C4.795 25.098 0 18.913 0 12.308V6.378c0-1.107.837-2.363 1.877-2.782L9.4.516a7 7 0 0 1 5.281 0l7.523 3.08c1.026.419 1.878 1.675 1.878 2.782z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#13A55B",
    d: "M15.41 11.474a3.378 3.378 0 0 0-6.754 0c0 1.513 1 2.769 2.364 3.201v3.552c0 .554.459 1.013 1.013 1.013a1.02 1.02 0 0 0 1.013-1.013v-3.552c1.364-.432 2.363-1.688 2.363-3.2"
  })));
};
export default SvgSecurity;